import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as $ from 'jquery';
import * as MenuAction from './MenuAction';
/**
 * 
 * RR_PC_20
 */
const ReplenPageLoad = (BO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ReplenishmentReview,
            SDIConstants.methodNames.ReplenishmentReview_Pageload,
            JSON.stringify(BO),

            (data) => {
                if (data.success) {
                    ;
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.ReplenishmentReview_Pageload, response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

/**
 * 
 * RR_PC_22
 */
const OnSiteSelectAction = (BO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ReplenishmentReview,
            SDIConstants.methodNames.ReplenishmentReview_VendorData,
            JSON.stringify(BO),

            (data) => {
                if (data.success) {
                    ;
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.ReplenishmentReview_VendorData, response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

/**
 * 
 * RR_PC_23
 */

const GetDataAction = (BO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ReplenishmentReview,
            SDIConstants.methodNames.ReplenishmentReview_GetData,
            JSON.stringify(BO),

            (data) => {
                if (data.success) {
                    ;
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.ReplenishmentReview_GetData, response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}


//CPW-97 Replenish Review - Add Item Image - Yuvarani K

const GetOtherData = (BO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ReplenishmentReview,
            SDIConstants.methodNames.ReplenishmentReview_GetOtherData,
            JSON.stringify(BO),

            (data) => {
                if (data.success) {
                    ;
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.ReplenishmentReview_GetOtherData, response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
/**
 * RR_PC_21
 * */
const ExportToExcelAction = (OrderStatusDataBO) => {
    try {
        //;
        SDISVC.downloadFile(
            SDIConstants.moduleNames.ReplenishmentReview,
            SDIConstants.methodNames.ReplenishmentReview_ExportToExcel,
            JSON.stringify(OrderStatusDataBO),
            "ReplenReport.xlsx",
            (data) => {
                if (data.success) {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        //;

                        let contentData = { type: SDIConstants.methodNames.ReplenishmentReview_ExportToExcel, response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
/**
 * 
 * RR_PC_
 */

const ProcessReplenClick = (BO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ReplenishmentReview,
            SDIConstants.methodNames.ReplenishmentReview_ProcessReplen,
            JSON.stringify(BO),

            (data) => {
                if (data.success) {
                    ;
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.ReplenishmentReview_ProcessReplen, response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

const UpdateItemAction = (BO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ReplenishmentReview,
            SDIConstants.methodNames.ReplenishmentReview_UpdateItem,
            JSON.stringify(BO),

            (data) => {
                if (data.success) {
                    ;
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.ReplenishmentReview_UpdateItem, response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

const OnStatusChangeAction = (BO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ReplenishmentReview,
            SDIConstants.methodNames.ReplenishmentReview_OnStatusChange,
            JSON.stringify(BO),

            (data) => {
                if (data.success) {
                    ;
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.ReplenishmentReview_OnStatusChange, response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

const insertFavPage = async (insertFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_InsertFavPage,
            JSON.stringify(insertFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_InsertFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const deleteFavPage = async (deleteFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_DeleteFavPage,
            JSON.stringify(deleteFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_DeleteFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const getCurrentFavPage = async (getFavPageBO) => {
    try {
        SDISVC.callRecurringGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_GetCurrentFavPage,
            JSON.stringify(getFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_CurrentFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
export { ReplenPageLoad, OnSiteSelectAction, GetDataAction, ExportToExcelAction, ProcessReplenClick, UpdateItemAction, OnStatusChangeAction, insertFavPage, deleteFavPage, getCurrentFavPage, GetOtherData }